import api from './api';
import type { CalendarDateResponse, CalendarMonthResponse } from '../types/calendar';

export const calendarApi = {
    /**
     * Get calendar info for a specific date
     * @param date - Date in YYYY-MM-DD format
     */
    async getDate(date: string): Promise<CalendarDateResponse> {
        const response = await api.get<CalendarDateResponse>(`/calendar/${date}`);
        return response.data;
    },

    /**
     * Get calendar info for an entire month
     * @param year - Year (YYYY)
     * @param month - Month (1-12)
     */
    async getMonth(year: number, month: number): Promise<CalendarMonthResponse> {
        const response = await api.get<CalendarMonthResponse>(`/calendar/month/${year}/${month}`);
        return response.data;
    },

    /**
     * Get calendar info for a date range
     * @param start - Start date (YYYY-MM-DD)
     * @param end - End date (YYYY-MM-DD)
     * @param limit - Max days to return
     */
    async getRange(start: string, end: string, limit = 365) {
        const response = await api.get('/calendar/range', {
            params: { start, end, limit },
        });
        return response.data;
    },
};

export default calendarApi;
